<template>
      <div class="panel history-bonus">
          <div class="title">
              <div class="col id">ID</div>
              <div class="col">Bonus</div>
              <div class="col">Tutar</div>
              <div class="col">Durum</div>
          </div>
          <div class="content">
              <div class="table-col">
                <div class="item" v-for="(item,key) in _.orderBy(finishedBonus, ['created_at'], ['desc'])" :key="key">
                  <div class="col id">#{{ item.user_bonus_id }}</div>
                  <div class="col"> <strong>{{ item.bonus_id_name }}</strong></div>
                  <div class="col"><b>{{ item.amount }}</b></div>
                  <div class="col">
                    <div class="status-label"  :class="'status_' + item.status" :style="!isMobile ? 'width:100px' : ''">{{ item.status_name }}</div>
                  </div>
                </div>
                <div class="alert" v-if="_.isEmpty(finishedBonus)">
                  Sonuç Bulunamadı
                </div>
              </div>
          </div>
      </div>
</template>
<script>
  export default{
    props:['finishedBonus'],
  }
</script>